import * as React from 'react';

import {colors} from '../colors/colors';
import {AiSparkleNewIcon} from '../icon/svg/ai-sparkle-new-icon';
import {Stack} from '../layout/stack/stack';
import {Body} from '../typography/body';

import styles from './nudge-input.module.css';

type Props = {
    appearanceColor?: string;
    appearanceCallToAction?: string;
};

export function NudgeInput(props: Props) {
    const {appearanceColor = '#6366f1', appearanceCallToAction = 'Ask anything!'} = props;

    const containerStyle = {
        '--appearance-color': appearanceColor,
    } as const;

    return (
        // @ts-expect-error
        <div style={containerStyle} className={styles['nudge-input-animated']}>
            <Stack isHorizontal={true} spacing={8} alignItems='center'>
                {/* @ts-expect-error */}
                <AiSparkleNewIcon size={16} color={colors.greyXlt} wrapWithDiv={false} />
                <Body color='placeholder'>{appearanceCallToAction}</Body>
            </Stack>
        </div>
    );
}
